const COLORS = {
  // Green family
  Active: 'bg-emerald-100 text-emerald-700', active: 'bg-emerald-100 text-emerald-700',
  approved: 'bg-emerald-100 text-emerald-700', completed: 'bg-emerald-100 text-emerald-700',
  Complete: 'bg-emerald-100 text-emerald-700', Paid: 'bg-emerald-100 text-emerald-700',
  green: 'bg-emerald-100 text-emerald-700', won: 'bg-emerald-100 text-emerald-700',
  done: 'bg-emerald-100 text-emerald-700', delivered: 'bg-emerald-100 text-emerald-700',
  permanent: 'bg-emerald-100 text-emerald-700', fulfilled: 'bg-emerald-100 text-emerald-700',
  sc: 'bg-emerald-100 text-emerald-700', dv: 'bg-emerald-100 text-emerald-700',
  edv: 'bg-emerald-100 text-emerald-700', received: 'bg-emerald-100 text-emerald-700',
  // Amber family
  pending: 'bg-amber-100 text-amber-700', draft: 'bg-amber-100 text-amber-700',
  Draft: 'bg-amber-100 text-amber-700', Awaiting: 'bg-amber-100 text-amber-700',
  amber: 'bg-amber-100 text-amber-700', not_started: 'bg-amber-100 text-amber-700',
  planning: 'bg-amber-100 text-amber-700', on_hold: 'bg-amber-100 text-amber-700',
  stale: 'bg-amber-100 text-amber-700', qualifying: 'bg-amber-100 text-amber-700',
  lead: 'bg-gray-100 text-gray-600', on_leave: 'bg-amber-100 text-amber-700',
  // Blue family
  in_progress: 'bg-blue-100 text-blue-700', Invoiced: 'bg-blue-100 text-blue-700',
  proposal: 'bg-blue-100 text-blue-700', negotiation: 'bg-purple-100 text-purple-700',
  submitted: 'bg-blue-100 text-blue-700', acknowledged: 'bg-purple-100 text-purple-700',
  on_order: 'bg-blue-100 text-blue-700', allocated: 'bg-blue-100 text-blue-700',
  in_transit: 'bg-blue-100 text-blue-700', contractor: 'bg-blue-100 text-blue-700',
  review: 'bg-purple-100 text-purple-700', fixed_term: 'bg-purple-100 text-purple-700',
  // SOW workflow statuses
  Issued: 'bg-blue-100 text-blue-700', 'Awaiting Payment': 'bg-teal-100 text-teal-700', Split: 'bg-gray-100 text-gray-500',
  'Not Won': 'bg-gray-100 text-gray-500', Expired: 'bg-orange-100 text-orange-700',
  // Red family
  overdue: 'bg-red-100 text-red-700', rejected: 'bg-red-100 text-red-700',
  red: 'bg-red-100 text-red-700', Cancelled: 'bg-red-100 text-red-700', 'Credit Noted': 'bg-red-100 text-red-700',
  cancelled: 'bg-red-100 text-red-700', blocked: 'bg-red-100 text-red-700',
  not_applicable: 'bg-red-100 text-red-700', left: 'bg-red-100 text-red-700',
  sick: 'bg-red-100 text-red-700',
  // Gray family
  todo: 'bg-gray-100 text-gray-600', not_ordered: 'bg-gray-100 text-gray-600',
  bpss: 'bg-gray-100 text-gray-600', none: 'bg-gray-100 text-gray-600',
  in_stock: 'bg-gray-100 text-gray-600', new: 'bg-gray-100 text-gray-600',
  annual: 'bg-blue-100 text-blue-700',
};

export default function Tag({ status, children }) {
  const display = children || status?.replace(/_/g, ' ') || '';
  const colors = COLORS[status] || 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex px-1.5 py-px rounded-md text-[9px] font-semibold ${colors}`}>
      {display}
    </span>
  );
}
